<!-- KonumlarComponent - Dialog Core içinde render ediliyor -->
<div style="width:100%;min-width:260px;">
    <!--  -->
    <div class="ui middle aligned selection list" style="margin:0;">

            <div class="ui placeholder segment" *ngIf="konumlar?.children.length < 1">
                <div class="ui icon header">
                    <img class="ui avatar image" src="./simgeler/kamera.webp"
                        style="width: 64px;height:64px;">
                    <br>
                    Kamera Konumu Yok
                </div>
                <div class="ui primary button"  (click)="tikandiEkleKonum();">Konum Ekle</div>
            </div>

            <div class="item" *ngFor="let kamera of konumlar?.children; let i = index" (click)="kamera.git()">

                <div class="right floated content">
                    <button class="ui icon mini button" title="Güncelle"
                        (click)="konumlar.children[i].kaydet();$event.stopPropagation();">
                        <i class="upload icon"></i>
                    </button>
                    <button class="ui icon mini button" title="Sil"
                        (click)="konumlar.children.splice(i,1);CD.detectChanges();FikoYT.degisti.emit();$event.stopPropagation();">
                        <i class="delete icon"></i>
                    </button>
                </div>

                <img class="ui avatar image" src="./simgeler/kamera.webp">
                <div class="content">
                    <div class="header" style="color: white !important;">{{ kamera.ismi ?? "İsim Verilmemiş" }}</div>
                    <div class="description" style="color: white !important;">{{kamera.aciklama ?? "Açıklama Yok"}}
                    </div>
                </div>
            </div>

        </div>
        <!--  -->
        <div class="ui divider" style="margin-top: 0.3rem;margin-bottom:0.1rem;"></div>

        <!-- Sabit Görünümler -->
        <div style="display: flex; gap: 0.3rem; margin-bottom: 0.5rem; flex-wrap: wrap;">
            <button class="ui icon mini button" title="İzometrik" (click)="gitSabitGorunum('isometrik');" style="padding: 0.3rem; min-width: 32px; min-height: 32px;">
                <i class="cube icon"></i>
            </button>
            <button class="ui icon mini button" title="Üst" (click)="gitSabitGorunum('ust');" style="padding: 0.3rem; min-width: 32px; min-height: 32px;">
                <i class="arrow up icon"></i>
            </button>
            <button class="ui icon mini button" title="Alt" (click)="gitSabitGorunum('alt');" style="padding: 0.3rem; min-width: 32px; min-height: 32px;">
                <i class="arrow down icon"></i>
            </button>
            <button class="ui icon mini button" title="Ön" (click)="gitSabitGorunum('on');" style="padding: 0.3rem; min-width: 32px; min-height: 32px;">
                <i class="arrow right icon"></i>
            </button>
            <button class="ui icon mini button" title="Arka" (click)="gitSabitGorunum('arka');" style="padding: 0.3rem; min-width: 32px; min-height: 32px;">
                <i class="arrow left icon"></i>
            </button>
            <button class="ui icon mini button" title="Sağ" (click)="gitSabitGorunum('sag');" style="padding: 0.3rem; min-width: 32px; min-height: 32px;">
                <i class="arrow right icon"></i>
            </button>
            <button class="ui icon mini button" title="Sol" (click)="gitSabitGorunum('sol');" style="padding: 0.3rem; min-width: 32px; min-height: 32px;">
                <i class="arrow left icon"></i>
            </button>
        </div>

        <div style="display: flex;">
            <button class="circular ui icon red mini button" title="Kaydet" (click)="tikandiEkleKonum();">
                <i class="record vinyl icon"></i>
            </button>

            <input class="fikoinput" type="text" #input placeholder="Konum İsmi" [ngModel]="ekleStr"
                (ngModelChange)="ekleStr=input.value;this.CD.detectChanges();">

            <div class="ui animated mini button" tabindex="0" (click)="kapa()" style="flex:75px;">
                <div class="visible content">Kapat</div>
                <div class="hidden content">
                    <i class="check icon"></i>
                </div>
            </div>
        </div>
</div>